import { render, staticRenderFns } from "./softDropSection.vue?vue&type=template&id=13a573dc"
import script from "./softDropSection.vue?vue&type=script&lang=js"
export * from "./softDropSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports